@for (status of statuses; track status) {
<div
  class="app-status-box"
  (click)="selectStatus(status)"
  [style]="{ 'border-color': '#000000' }"
>
  @if (status.icon !== null && status.icon.name !== null) {
  <mat-icon>
    {{ status.icon.name }}
  </mat-icon>
  } @else {
  <mat-icon> cancel </mat-icon>
  }
  {{ status.name }}
</div>
}
